// import React, { useState, useEffect, useMemo } from "react";
import React, { useState, useEffect, useMemo, useRef } from "react";

import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Select from "react-select";

import { MdSync } from "react-icons/md";
import redirectURL from "../../redirectURL";
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import dsStorescsv from "../../../assets/json/dsstores.csv";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const STNStockStatus = () => {
  const gridRef = useRef(null);

  const [selectedStatus, setSelectedStatus] = useState({
    label: "ALL",
    value: "none",
  });
  const [availableDates, setAvailableDates] = useState([]);
  const [currentinvoiceDate, setCurrentInvoiceDate] = useState(() => {
  const today = new Date()
    return today.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });; // "YYYY-MM-DD"
  });
  const [prevDate, setPrevDate] = useState([]);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null); // or 0 if default is number
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [currentUploadedDate, setCurrentUploadedDate] = useState(new Date()); // or new Date() if it's a date object
  const [show, setShow] = useState(false);
  const [basicType, setBasicType] = useState(""); // "info" or "success"
  const [basicTitle, setBasicTitle] = useState(""); // alert title message
  const [loadshow, setLoadshow] = useState("show-n"); // "show-m" to show, "show-n" to hide
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [file, setFile] = useState(null);
  const [selectedDs, setSelectedDs] = useState(null);
  const [darkStoreData, setDarkStoreData] = useState([]);
  const [filename, setFilename] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);
  const [stnDuplicateData, setStnDuplicateData] = useState([]);
  const [confirmPopup, setConfirmPopup] = useState(false)
  
  // URL Update Modal States
  const [showUrlUpdateModal, setShowUrlUpdateModal] = useState(false);
  const [newUrl, setNewUrl] = useState("");
  const [urlError, setUrlError] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [urlMonth, setUrlMonth] = useState(null);
  const [highlightedDates, setHighlightedDates] = useState([]);


const applyFilter = async () => {
  setLoadshow("show-m")
  setOverlayBlock("show-m"); // show loader

  try {
    // 🔹 First fetch latest data for selected date
    const dateToUse = new Date(currentinvoiceDate)?.toISOString().split("T")[0] || new Date().toISOString().split("T")[0];
    const params = { date: dateToUse };
    const response = await redirectURL.post("inventory/getStnStockData", params);
    const dates = response.data.dates.map(d=> new Date(d))
    setHighlightedDates(dates)

    if (response.data.status === "success") {
      setCurrentInvoiceDate(dateToUse);
      setStnDuplicateData(response.data.data);
      // 🔹 Apply filtering based on selectedStatus
      let currentData = [];
      if (selectedStatus?.value !== "none") {
        if (selectedStatus?.label === "Not Specified") {
          const values = statusOptions.map((item) => item.value);
          // currentData = response.data.data.filter(
          //   (item) => !values.includes(item.current_status)
          // );
          currentData = response.data.data.filter(
  (item) => !values.includes(item.status || item.current_status)
);
        } else {
          // currentData = response.data.data.filter(
          //   (item) => item.current_status === selectedStatus?.value
          // );
          currentData = response.data.data.filter(
  (item) => (item.status || item.current_status) === selectedStatus?.value
);
        }
      } else {
        currentData = response.data.data;
      }

      setDarkStoreData(currentData);
      if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.setFilterModel(null); // Clear all filters
      gridRef.current.api.refreshCells({ force: true }); // Refresh cells
      gridRef.current.api.onFilterChanged(); // Re-apply filters
      }
    } else {
      setDarkStoreData([]);
    }
  } catch (error) {
    console.error("Error fetching filtered data", error);
  } finally {
    setLoadshow("show-n")
    setOverlayBlock("show-n");; // hide loader
  }
};

  const getDarkStoreData = async () => {
    const dateToUse =
      currentinvoiceDate || new Date().toISOString().split("T")[0]; // fallback to today
    const params = { date: dateToUse };
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      const response = await redirectURL.post(
        "inventory/getStnStockData",
        params
      );
      const dates = response.data.dates.map(d=> new Date(d))
      setHighlightedDates(dates)

      setLoadshow("show-n");
      setOverlayBlock("show-n");

      if (response.data.status === "success") {
        setCurrentInvoiceDate(dateToUse);
        setDarkStoreData(response.data.data);
        setStnDuplicateData(response.data.data);
        setStatusOptions([
          ...response.data.status_options,
          { label: "ALL", value: "none" },
        ]);
      } else {
        setCurrentInvoiceDate(dateToUse);
        setDarkStoreData(response.data.data);
        setShow(true);
        setBasicType("info");
        setBasicTitle("No Data Found");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to getting data";
      console.log({ errorMessage });
    }
  };

  const getResetDarkStoreData = async () => {
   const today = new Date();
  const dateString = today.toISOString().split("T")[0];
  const params = { date: dateString };
  setCurrentInvoiceDate(today)
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      const response = await redirectURL.post(
        "inventory/getStnStockData",
        params
      );
      setLoadshow("show-n");
      setOverlayBlock("show-n");

      if (response.data.status === "success") {
      const responseDate = response.data.date ? new Date(response.data.date) : today;
      setCurrentInvoiceDate(responseDate);
      setSelectedStatus({ label: "ALL", value: "none" });
      setDarkStoreData(response.data.data);
      } else {
        //   setShow(true);
        //   setBasicType("info");
        //   setBasicTitle("Data Upload Failed");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to getting data";
      console.log({ errorMessage });
    }
  };

  useEffect(() => {
    getDarkStoreData();
    // setDarkStoreData(currentRowData);
  }, []);

  //   const handleReset = () => {
  //     setCurrentDate(null);
  //     setSelectedStatus({ label: "DS1", value: "DS1" });
  //     const defaultData = dummyData.filter((row) => row.store === "DS1");
  //     setFilteredData(defaultData);
  //   };

  const checkDataExistsWithDate = async (params) => {
    try{
      const response = await redirectURL.post(
        "inventory/checkDataExistsWithDate",
        params
      );
      if (response.data.status === "success") {
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Checked STN Data exists or not",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
        return response.data.exists;
      } else {
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Checked STN Data exists or not",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
        return response.data.exists;
      }
    }catch(err){
      console.log(err);
      return false;
    }
  }

  // Function To Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }
  
  const fetchAndAddStnData = async (params) => {
    setOverlyBlock("show-m");
    setLoadshow("show-m");
    try {
      const response = await redirectURL.post(
        "/inventory/fetchAndInsertSTNData",
        params
      );
        setOverlyBlock("show-n");
        setLoadshow("show-n");

        if (response.data.url_update && response.data.url_update == 1){
            // User Action Triggering Starts Here
          var userData = {
            email: localStorage.getItem("email"),
            user_code: localStorage.getItem("user_code"),
            action: "Updated STN URL",
            status: "Success",
            path: window.location.pathname
          }
          triggerUserAction(userData)
          // User Action Triggering Ends Here
          // Show URL update modal
          setSelectedMonth(response.data.selected_month);
          setUrlMonth(response.data.url_month);
          setShowUrlUpdateModal(true);
          return;
        }
    
      if (response.data.status === "success") {
        getDarkStoreData();
        setShow(true);
        setBasicType("success");
        setBasicTitle(response.data.message);
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Fetched STN Data",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
      else if (response.data.status === "info") {
        setShow(true);
        setBasicType("info");
        setBasicTitle(response.data.message);
      }
    } catch (err) {
      setShow(true);
      setBasicType("info");
      setBasicTitle(err.response?.data?.message || "Failed to upload STN data");
      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Fetched STN Data",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    } finally {
      setOverlyBlock("show-n");
      setLoadshow("show-n");
    }
  }

  const fetchFromApi = async () => {
    const fetch_date = new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

    setOverlyBlock("show-m");
    setLoadshow("show-m");

    try {
      const response = await redirectURL.post("inventory/fetchInTransitStockData", {
        fetch_date,
      });

      const res = response?.data?.pyResponse;

      if (res?.status === "Success") {
        setShow(true);
        setBasicType("success");
        setBasicTitle(res.message || "In Transit Stock Data Fetched Successfully");
        await getDarkStoreData();

        triggerUserAction({
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Fetched In Transit Stock Data from API",
          status: "Success",
          path: window.location.pathname,
        });
      } else {
        setShow(true);
        setBasicType("info");
        setBasicTitle(res?.message || "Failed to fetch In Transit Stock Data");

        triggerUserAction({
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Fetched In Transit Stock Data from API",
          status: "Failure",
          path: window.location.pathname,
        });
      }
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle(
        error.response?.data?.message || "Failed to fetch In Transit Stock Data"
      );

      triggerUserAction({
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Fetched In Transit Stock Data from API",
        status: "Failure",
        path: window.location.pathname,
      });
    } finally {
      setOverlyBlock("show-n");
      setLoadshow("show-n");
    }
  };

  const checkTriggerStatus = async (date) => {
    try {
        const response = await redirectURL.post("inventory/checkIsTriggerDone", { trigger_date: date });
        return response?.data?.status === "success"
          ? response.data.exists
          : false;

      } catch (err) {
        console.error("Error checking data:", err);
        return false; // always return boolean
      }
  }

  const onClickUploadSkuMasterData = async (e) => {
    e.preventDefault();

    const date = currentinvoiceDate || new Date().toISOString().split("T")[0];
    var params = { uploaded_date: date };
    setOverlyBlock("show-m");
    setLoadshow("show-m");

    const isTriggered = await checkTriggerStatus(date);

    if (isTriggered) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("To Re Fetch STN Data, Kindly Revoke Trigger Inventory");
      return;
    }


    const isExistsData  = await checkDataExistsWithDate(params);

    if(isExistsData){
      setOverlyBlock("show-n");
      setLoadshow("show-n");
      setConfirmPopup(true)
      return
    }
    await fetchAndAddStnData(params);

  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    // resetFormData();
    setUploadedFileData([]);
  };

  const onClickingFileSubmit = async () => {
    if (uploadedFileData.length === 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please upload a file");
      return;
    }

    const params = {
      date: currentUploadedDate,
      dark_store_id: selectedDs?.value || "",
      dark_store_name: selectedDs?.label || "",
      masterData: uploadedFileData,
      filename,
    };

    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      const response = await redirectURL.post(
        "inventory/storeDarkStoreData",
        params
      );

      if (response.data.status === "success") {
        //   await getDarkStoreData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Data Uploaded Successfully");
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Data Upload Failed");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to upload data";
      setShow(true);
      setBasicType("info");
      setBasicTitle(errorMessage);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  const stnDataCols = [
    { headerName: "Requested By", field: "requested_by", hide: true },
    { headerName: "Date", field: "date", hide: true },
    { headerName: "M Date", field: "m_date" },
    { headerName: "Consignor Name", field: "consignor_name", hide: true },
    { headerName: "Consignee Name", field: "consignee_name", hide: true },
        { headerName: "From", field: "from",hide: true },

    { headerName: "Destination", field: "to" },
    { headerName: "Delivery Address", field: "delivery_address", hide: true },
    { headerName: "POC Name", field: "poc_name", hide: true },
    { headerName: "Contact No", field: "contact_no", hide: true },
    { headerName: "Issued For", field: "issued_for", hide: true },
    { headerName: "SKU", field: "sku" },
    { headerName: "Batch No", field: "batch" },
    { headerName: "Requested Qty", field: "quantity_sent", hide: true },
    { headerName: "Dispatched Qty", field: "quantity_sent" },
    { headerName: "B2C Qty", field: "b2_c_qty", hide: true },
    { headerName: "Short Qty", field: "short_qty", hide: true },
    { headerName: "Gate Pass", field: "gate_pass", hide: true },
    { headerName: "AWB", field: "awb", hide: true },
    { headerName: "Dispatch Date", field: "dispatch_date", hide: true },
    {
      headerName: "Tentative Delivery Date",
      field: "tentative_delivery_date",
      hide: true,
    },
    {
      headerName: "Actual Delivery Date",
      field: "actual_delivery_date",
      hide: true,
    },
    { headerName: "Planning Check", field: "planning_check", hide: true },
    { headerName: "HSN Code", field: "hsn_code", hide: true },
    { headerName: "STN Date", field: "stn_date", hide: true },
    { headerName: "STN No", field: "stn_no", hide: true },
    { headerName: "Remarks", field: "remarks_if_any", hide: true },
    { headerName: "Vehicle No", field: "vehicle_no", hide: true },
    { headerName: "Delivery Partner", field: "delivery_partner", hide: true },
    { headerName: "Case Size", field: "case_size", hide: true },
    // { headerName: "Current Status", field: "status" },
    {
  headerName: "Status",
  valueGetter: (params) => params.data.status || params.data.current_status || ""
},
    { headerName: "Sheet Name", field: "sheet_name",hide: true },

    { headerName: "Uploaded Date", field: "uploaded_date", hide: true },
  ];

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value);
    const filename = file.name;
    setFilename(filename);
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });

      // const mapping = {
      //     "Destination Store Id": "destination_store_id",
      //     "SKU Code": "sku_code",
      //     "Sale Quantity": "sale_quantity",
      // };

      function toSnakeCase(str) {
        return str
          .trim()
          .replace(/\s+/g, "_") // replace spaces with underscores
          .replace(/[A-Z]/g, (letter) => letter.toLowerCase()) // lowercase any capitals
          .replace(/[^a-z0-9_]/g, ""); // remove any special chars if needed
      }

      // transform
      const result = parsedData.map((item) => {
        const newItem = {};
        for (const key in item) {
          // if (mapping[key]) {
          //     // if in mapping use mapped version
          //     newItem[mapping[key]] = item[key];
          // } else {
          // if not in mapping, convert key to snake_case
          newItem[toSnakeCase(key)] = item[key];
          // }
        }
        return newItem;
      });

      console.log("Parsed Data:", result);
      setUploadedFileData(result);
    };
    reader.readAsArrayBuffer(file);
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setCurrentUploadedDate("");
    setUploadedFileData([]);
  };

  const downloadExcelTemplate = async () => {
    try {
      const response = await fetch(dsStorescsv);
      const csvText = await response.text();
      const rows = csvText
        .trim()
        .split("\n")
        .map((line) => line.split(","));

      const ws = utils.aoa_to_sheet(rows);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Sheet1");

      writeFile(wb, "sample_darkstore_template.xlsx");
    } catch (error) {
      console.error("Error downloading or parsing CSV:", error);
    }
  };

  const closeAlert = () => {
    const fileInput = document.getElementById("bulkUploadFile");
    if (fileInput !== null) {
      // Check if the element exists
      fileInput.value = ""; // Clears the input if element exists
    }

    setUploadedFileData([]);
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setSliderOpen(false);
    setCurrentUploadedDate("");
  };

  // URL Update Modal Functions
  const validateUrl = (url) => {
    return url.startsWith("https://docs.google.com/spreadsheets");
  };

  const handleUrlChange = (e) => {
    const url = e.target.value;
    setNewUrl(url);
    setUrlError("");
    
    if (url && !validateUrl(url)) {
      setUrlError("URL must start with https://docs.google.com/spreadsheets");
    }
  };

  const handleUrlUpdate = async () => {
    // url formats
    // https://docs.google.com/spreadsheets/d/1-vimQh4ezgDnjSho4mgOgYt17E21orVMvKRNlfA0ZQk
    // https://docs.google.com/spreadsheets/d/1-vimQh4ezgDnjSho4mgOgYt17E21orVMvKRNlfA0ZQk/
    // https://docs.google.com/spreadsheets/d/1-vimQh4ezgDnjSho4mgOgYt17E21orVMvKRNlfA0ZQk/export?format=xlsx
    // https://docs.google.com/spreadsheets/d/1-vimQh4ezgDnjSho4mgOgYt17E21orVMvKRNlfA0ZQk/edit?gid=1582131977#gid=1582131977

    if (!newUrl.trim()) {
      setUrlError("Please enter a URL");
      return;
    }

    // Accept only the 4 valid formats
    // 1. .../d/<id>
    // 2. .../d/<id>/
    // 3. .../d/<id>/export?format=xlsx
    // 4. .../d/<id>/edit?gid=...#gid=...
    const validPatterns = [
      /^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+$/,
      /^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+\/$/,
      /^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+\/export\?format=xlsx$/,
      /^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+\/edit\?gid=[^#\/]+#gid=[^\/]+$/
    ];

    let isValid = false;
    for (let pattern of validPatterns) {
      if (pattern.test(newUrl.trim())) {
        isValid = true;
        break;
      }
    }

    if (!isValid) {
      setUrlError(
        "Invalid URL format. Please enter a valid Google Sheet URL."
      );
      return;
    }

    // Now, normalize the URL to always use the /export?format=xlsx format for backend
    let finalUrl = newUrl.trim();

    // If it's already in /export?format=xlsx, use as is
    if (/\/export\?format=xlsx$/.test(finalUrl)) {
      // do nothing
    }
    // If it's in /edit?gid=...#gid=..., convert to /export?format=xlsx
    else if (/\/edit\?gid=[^#\/]+#gid=[^\/]+$/.test(finalUrl)) {
      // Remove /edit?gid=...#gid=...
      finalUrl = finalUrl.replace(/\/edit\?gid=[^#\/]+#gid=[^\/]+$/, "");
      finalUrl = finalUrl.replace(/\/$/, ""); // remove trailing slash if any
      finalUrl = finalUrl + "/export?format=xlsx";
    }
    // If it ends with a slash, remove it
    else if (/^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+\/$/.test(finalUrl)) {
      finalUrl = finalUrl.replace(/\/$/, "");
      finalUrl = finalUrl + "/export?format=xlsx";
    }
    // If it's just .../d/<id>
    else if (/^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+$/.test(finalUrl)) {
      finalUrl = finalUrl + "/export?format=xlsx";
    }
 
    // console.log(finalUrl, "finalUrl");
 
    setLoadshow("show-m");
    setOverlayBlock("show-m");
 
    try {
      // Update the URL in the database with the properly formatted URL
      const updateResponse = await redirectURL.post("/inventory/updateStnUrl", {
        url: finalUrl,
        month: selectedMonth
      });
 
      if (updateResponse.data.status === "success") {
        // Close modal and re-execute the original fetchAndInsertSTNData logic
        setShowUrlUpdateModal(false);
        setNewUrl("");
        setUrlError("");
       
        // Re-execute the fetchAndInsertSTNData with the same parameters
        const date = currentinvoiceDate || new Date().toISOString().split("T")[0];
        const params = { uploaded_date: date };
       
        // Call the original function again
        await fetchAndAddStnData(params);
      } else {
        setShow(true);
        setBasicType("info");
        setBasicTitle(updateResponse.data.message || "Failed to update URL");
      }
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle(error.response?.data?.message || "Failed to update URL");
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  const closeUrlUpdateModal = () => {
    setShowUrlUpdateModal(false);
    setNewUrl("");
    setUrlError("");
    setSelectedMonth(null);
    setUrlMonth(null);
  };

  const sideBar = useMemo(
    () => ({
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
        },
      ],
    }),
    []
  );

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left",
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center",
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" },
    ],
  };

  return (
    <div className="container-fluid mt-3">
      <div style={{ zIndex: "9999999" }}>
        <SweetAlert
          show={show}
          type={basicType}
          title={basicTitle}
          onConfirm={closeAlert}
          style={{ fontSize: "9px" }}
        ></SweetAlert>
      </div>

      <div className="row mt-3">
        <form
          className="col-sm-12 p-0 mt-4 mb-4"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div className="col-sm-8 row ">
            <div style={{ display: "flex", flexDirection: "column" , marginLeft : "10px" }}>
            <label style={{ fontSize: "13px", fontWeight: "400" }}>Uploaded Date:</label>
             <DatePicker
                selected={new Date(currentinvoiceDate)}
                onChange={(date) => {
                  setPrevDate(new Date(currentinvoiceDate));
                  setCurrentInvoiceDate(date);
                }}
                maxDate={new Date()}
                dateFormat="yyyy-MM-dd"
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                wrapperClassName="w-full"
                highlightDates={[
                  {
                    "react-datepicker__day--highlighted-custom": highlightedDates,
                  },
                ]}
              />
            </div>

            <div
              className="ml-4 mt-4"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "0px 10px",
              }}
            >
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  // getDarkStoreData();
                  applyFilter()
                }}
                style={{
                  backgroundColor: "#93385D",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "8px 20px",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Apply
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  getResetDarkStoreData();
                }}
                type="button"
                style={{
                  backgroundColor: "#fff",
                  color: "#000",
                  borderRadius: "5px",
                  padding: "8px 20px",
                  border: "1px solid #d9d9d9",
                  cursor: "pointer",
                }}
              >
                Reset
              </button>
            </div>
          </div>
          <div
            className="col-sm-4 text-right p-0"
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                fetchFromApi();
              }}
              className="add-button upload-add-button"
            >
              <MdSync style={{ color: "#93385D", fontSize: "18px" }} />
              <span style={{ marginLeft: "6px" }}>Fetch STN Data</span>
            </button>
            {/* <button
              onClick={onClickUploadSkuMasterData}
              className="add-button upload-add-button"
            >
              <MdSync style={{ color: "#93385D", fontSize: "18px" }} />
              <span style={{ marginLeft: "6px" }}>Fetch STN Data</span>
            </button> */}
          </div>
        </form>
      </div>

      <div className="ag-theme-alpine " style={{ height: 500, width: "100%" }}>
        <AgGridReact
          ref={gridRef}
          rowData={darkStoreData}
          columnDefs={stnDataCols}
          defaultColDef={{ resizable: true, sortable: true, filter: true }}
          domLayout="normal"
          suppressHorizontalScroll={false} // allow scroll
          sideBar={sideBar}
          statusBar={statusPanel}
          // pagination={true}
          // paginationPageSize={100}
          enableRangeSelection={true}
          gridOptions={{
            suppressHorizontalScroll: false,
          }}
        />
      </div>
      <div
        className={`stock-status-slider ${
          isSliderOpen ? "open" : ""
        } ${sliderCl}`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>

        {sliderType === 1 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <form
              style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
              onSubmit={(e) => {
                e.preventDefault();
                onClickingFileSubmit();
              }}
            >
              <div className="d-flex justify-content-end mb-10p">
                <div>
                  <button onClick={downloadExcelTemplate}>
                    Download Sample Template (.xlsx)
                  </button>
                </div>
              </div>
              <div className="mt-2">
                <label
                  htmlFor="store"
                  style={{ fontSize: "13px", fontWeight: "400" }}
                >
                  Select DS Store:
                </label>
                <Select
                  id="store"
                  options={statusOptions}
                  value={selectedDs}
                  onChange={(option) => setSelectedDs(option)}
                  placeholder="Choose DS"
                  styles={selectStyles}
                />
              </div>
              <div
                className="mb-1 mt-4"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  Date:
                </label>
                <input
                  type="date"
                  id="uploadDate"
                  value={currentUploadedDate}
                  onChange={(e) => {
                    setCurrentUploadedDate(e.target.value);
                  }}
                  style={{
                    padding: "7px",
                    borderRadius: "5px",
                    border: "1px solid #d9d9d9",
                    width: "100%",
                    marginBottom: "15px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    document.getElementById("uploadDate").showPicker?.()
                  }
                  required
                />
              </div>

              <input
                className="mt-3"
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
                style={{
                  border: "1px solid lightgrey",
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                  color: "#000",
                  fontSize: "13px",
                }}
                id="bulkUploadFile"
                required
              />
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  margin: "0px",
                  marginTop: "10px",
                }}
              >
                *Accept .csv & .xlsx files only
              </p>

              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  className="btn btn-success"
                  style={{
                    color: "#fff",
                    fontSize: "0.8rem",
                    backgroundColor: "#93385D",
                  }}
                  type="submit"
                >
                  {"Submit"}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
      {confirmPopup && (
            <div className="popup-overlay">
              <div className="popup-box">
                <h3>Data already exists</h3>
                {/* <p>Uploading will overwrite the existing data. Do you want to continue?</p> */}
                 <p style={{ marginBottom: "20px", fontSize: "14px", color: "#555" }}>
                    Data for <b>{new Date().toISOString().split("T")[0]}</b> already exists.
                    Do you want to Re Upload the data ?
                  </p>
                <div className="popup-actions">
                  <button
                    onClick={ async () => {
                      setConfirmPopup(false);
                      await fetchAndAddStnData({ uploaded_date: new Date().toISOString().split("T")[0] });
                      // handleDataUpload("re_upload");
                    }}
                    className="yes-btn"
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => setConfirmPopup(false)}
                    className="no-btn"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
      )}

      {/* URL Update Modal */}
      {showUrlUpdateModal && (
        <div className="popup-overlay">
          <div className="popup-box" style={{ maxWidth: "500px" }}>
            <h3>Update Google Sheet URL</h3>
            <p style={{ marginBottom: "20px", fontSize: "14px", color: "#555" }}>
              The URL for month {selectedMonth} ({selectedMonth ? new Date(0, selectedMonth - 1).toLocaleString('default', { month: 'long' }) : ""}) needs to be updated. 
              Current URL is for month {urlMonth} ({urlMonth ? new Date(0, urlMonth - 1).toLocaleString('default', { month: 'long' }) : ""}).
            </p>
            
            <div style={{ marginBottom: "15px" }}>
              <label style={{ display: "block", marginBottom: "5px", fontSize: "14px", fontWeight: "500" }}>
                New Google Sheet URL:
              </label>
              <input
                type="url"
                value={newUrl}
                onChange={handleUrlChange}
                placeholder="https://docs.google.com/spreadsheets/..."
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: urlError
                    ? "1px solid #ff4444"
                    : "1.5px solid #e0e0e0", // light border by default
                  fontSize: "14px",
                  outline: "none",
                  transition: "border-color 0.2s",
                }}
                onFocus={e => {
                  e.target.style.border = urlError
                    ? "1px solid #ff4444"
                    : "1.5px solid #93385D";
                }}
                onBlur={e => {
                  e.target.style.border = urlError
                    ? "1px solid #ff4444"
                    : "1.5px solid #e0e0e0";
                }}
              />
              {urlError && (
                <p style={{ color: "#ff4444", fontSize: "12px", margin: "5px 0 0 0" }}>
                  {urlError}
                </p>
              )}
            </div>

            <div className="popup-actions">
              <button
                onClick={handleUrlUpdate}
                className="yes-btn"
                style={{ marginRight: "10px" }}
              >
                Update
              </button>
              <button
                onClick={closeUrlUpdateModal}
                className="no-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
      <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </div>
  );
};

const selectStyles = {
  control: (base) => ({
    ...base,
    padding: "1px",
    borderRadius: "5px",
    border: "1px solid #d9d9d9",
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: "normal", // <-- make the text not bold
    color: "#333",
    fontSize: "12px", // optional: adjust color
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "13px",
    fontWeight: state.isSelected ? "normal" : "normal", // make options also normal if you wish
  }),
};

export default STNStockStatus;
